<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import LoadingView from "../../../../../component/common/Loading/LoadingView.svelte";
    import {MouseEnterTipsViewUtil} from "../../../../../component/common/Information/MouseEnterTipsViewUtil";
    import {BinaryTable} from "../../../../../lib/Table/BinaryTable";

    const dispatcher = createEventDispatcher();
    export let binary;

    $: iconClassName = (() => {
        const classArray = [];
        if (binary == null) {
            return classArray.join(' ');
        }

        const autoDeleteType = binary.auto_delete_type;


        if (autoDeleteType === BinaryTable.AutoDeleteType.Keep) {
            classArray.push('keep');
        } else if (autoDeleteType === BinaryTable.AutoDeleteType.KeepForever) {
            classArray.push('keep forever');
        }

        return classArray.join(' ');
    })();

    let isLoading = false;


    onMount(() => {
    });

    function change() {
        const paramMap = {};

        paramMap['space_id'] = binary.space_id;
        paramMap['id'] = binary.id;

        paramMap['auto_delete_type'] = binary.auto_delete_type;

        const url = UrlUtil.createApiUrl("binary");

        isLoading = true;
        HttpRequestUtil.postRequest(url, paramMap, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];


        });
    }


    function onChange() {
        if (isLoading) {
            return;
        }

        change();
    }

</script>

<span class='binary-delete-protect-view'
      class:loading={isLoading}
      on:mouseenter={(event)=>{
          const messageArray = [];
          messageArray.push('10分に1回、裏で実行されるバイナリ自動削除に対する挙動が設定できます。');
          messageArray.push('');
          // Object.entries(BinaryTable.AutoDeleteType.map) as [id, name]
          for(let type in BinaryTable.AutoDeleteType.map){
              messageArray.push(BinaryTable.AutoDeleteType.getDescription(type));
          }
          const message = messageArray.join("\n");


          MouseEnterTipsViewUtil.show(event, message);
      }}
>

    <span class="content">
        <span class={`icon ${iconClassName}`}>
            <FontAwesomeView icon="lock"/>
        </span>

        <span class="type-select">
            <select bind:value={binary.auto_delete_type} on:change={onChange}>
                {#each Object.entries(BinaryTable.AutoDeleteType.map) as [key, name]}
                    <option value={Number(key)}>{name}</option>
                {/each}
            </select>

        </span>
    </span>


    {#if isLoading}
        <span class="loading-area">
            <LoadingView/>
        </span>
    {/if}

</span>


<style lang="scss">
    .binary-delete-protect-view {

        cursor: pointer;
        display: inline-block;
        position: relative;

        .content {
            .icon {
                opacity: 0.25;
                transition-duration: 0.25s;
                display: inline-block;

                &.keep {
                    opacity: 1;
                    transform: scale(1.5);
                    color: var(--color6);

                    &.forever {
                        color: var(--color9);
                    }
                }
            }

            .type-select {
                transition-duration: 0.25s;
                font-size: 0.75em;
                opacity: 0;
            }
        }


        .loading-area {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            display: block;
        }

        &.loading {
            pointer-events: none;

            .content {
                opacity: 0;
            }


        }


        &:hover {

            .type-select {
                opacity: 1;
                margin-left: 0.5em;
            }


        }
    }
</style>